export const inputMinStyles = {
  fontSize: '12px',
  lineHeight: '1.2',
  paddingTop: '6px',
  paddingBottom: '6px',
  paddingLeft: '0px',
  height: '30px'
}
